// actions.ts
import { Context, IActions } from './actions.types'
import { AppConstants as _app } from '@/shared/app.constants'
import { Notification, INotification } from '@/entities'

export const actions: IActions = {
   
    /** get the communication data */
    getTracker(context: Context, id: number): any {
        if(id) {         
            return this.$services.communication.getTrackerById(id)
            .then((data: any) => {
                context.commit('setTracker', { trackerResp: data });
                return data;
            }).catch((e) => {
                context.commit('application/updateOverlay', false, { root: true });
                context.commit('application/setNotification', new Notification({ snack: true, text: e, color: 'error' } as INotification),  { root: true });
            });
        }
    },

    /** update the communication report */
    updateTracker(context: Context, payload: any): any {
        return this.$services.communication.updateTracker(payload.id, payload.data)
        .then((resp) => {
            if(resp.Result == 'OK') {
                context.commit('application/setNotification', new Notification({ snack: true, text: 'Record saved successfully', color: 'success' } as INotification),  { root: true });         
                return true;
            }
            else {
                context.commit('application/setNotification', new Notification({ snack: true, text: resp.Message, color: 'error' } as INotification),  { root: true });
                return false;
            }                
        }).catch((e) => {
            context.commit('application/updateOverlay', false, { root: true });
            context.commit('application/setNotification', new Notification({ snack: true, text: e, color: 'error' } as INotification),  { root: true });
        });
    },

    // /** submit the communication report */
    // submitReport(context: Context, report: any): any {
    //     report.Status = _app.commReportStatus.completed;
    //     return this.$services.communication.submitReport(report)
    //     .then((resp) => {
    //         context.commit('setCommunicationData', { comm: resp.Record });
    //         context.commit('application/setNotification', new Notification({ snack: true, text: 'Record saved successfully', color: 'success' } as INotification),  { root: true });         
    //     });;
    // },

    // /** upload the document */
    // uploadDocument(context: Context, payload: any) {
    //     context.commit('application/updateOverlay', true, { root: true });
    //     return this.$services.document.uploadDocument(payload.file, payload.schema, payload.transactionId || context.state.communication.GrantCommunicationId, payload.language, payload.multiple)
    //     .then((resp) => {
    //         context.commit('application/updateOverlay', false, { root: true });
    //         return resp;
    //     }).catch((e) => {
    //         context.commit('application/updateOverlay', false, { root: true });
    //         context.commit('application/setNotification', new Notification({ snack: true, text: e, color: 'error' } as INotification),  { root: true });
    //     })
    // }
}